/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import Form from 'components/react-validation/components/form';
import Input from 'components/react-validation/components/input';
import Textarea from 'components/react-validation/components/text-area';
import Submit from 'components/react-validation/components/submit';
import * as Vali from 'helper/validator-helper';
import emptyImages from 'assets/img/empty-images.svg';
import Dropzone from 'react-dropzone';
import {connect} from 'react-redux';
import * as CommonActionType from 'Common/constants';
import { v4 as uuidv4 } from 'uuid';
import { isEmpty } from 'lodash';
import { Dropdown } from 'components/Dropdown/Dropdown';
import Datetime from 'react-datetime';
import {isMobile} from 'react-device-detect';
import { generatePdfThumbnail } from '../../../helper/generate-pdf-thumbnail';
import plusIcon from 'assets/img/add-plus-icon.svg';
import calendarDateImg from 'assets/img/event-black.svg';
import regularDate from 'assets/img/view-day-back.svg';
import word from 'assets/img/file_word.png';
import excel from 'assets/img/file_excel.png';
import pdf from 'assets/img/file_pdf.png';
import ppt from 'assets/img/file_pp.png';
import video from 'assets/img/file_video.png';
import other from 'assets/img/file_other.png';
import * as ProjectActionType from 'Projects/constants';
import { Breadcrumb } from 'components/breadcrumb/breadcrumb';
import Moment from 'moment';
import Autocomplete from 'react-autocomplete';
import { formatTimezoneDateTime } from 'helper/unit-helper';
import { debounce } from 'lodash';
import PreviewVideoWO from 'Work-Orders/Components/PreviewVideoWO';
import { PreviewImage } from 'components/PreviewImage';
// const MAXIMUM_VIDEO_SIZE = 1024 * 1024 * 500;

const monthYearType = {
  month: 0,
  year: 1
};
const dateType = {
  coe: 0,
  purchaseDate: 1
};
const warrantyTypeSelection = [{text: 'COE', value: dateType.coe}, {text: 'Purchase date', value: dateType.purchaseDate}];
const warrantyDateTimeSelection = [{text: 'months', value: monthYearType.month}, {text: 'years', value: monthYearType.year}];
class AddNewInventoryItemsModal extends React.Component {
    static propTypes = {
      onClose: PropTypes.func,
      dispatch: PropTypes.func,
      projectId: PropTypes.string,
      breadcrumbsHistory: PropTypes.string,
      onProceedToAssignLot: PropTypes.func,
      categoryDropdownList: PropTypes.array,
      SuggestInventoryItemInfo: PropTypes.array,
      templateInventoryItemProfile: PropTypes.array,
      isViewDetail: PropTypes.bool,

    }
    constructor(props) {
      super(props);
      this.state = {
        name: '',
        model: '',
        mfg: '',
        note: '',
        style: '',
        price: '',
        category: null,
        categoryList: [],
        calendarDate: null,
        warrantyExpiration: {
          warrantyDate: null,
          warrantyMonthYear: warrantyDateTimeSelection[0],
          warrantyType: warrantyDateTimeSelection[0]
        },
        cancelUploadList: {},
        deleteUploadList: {},
        listImages: [],
        attachmentFiles: [],
        imagePreview: null,
        isAttachment: true,
        showDialog: false,
        suggestData: [],
        openSelectedCalendarDate: false,
        errorMessageAutoComplete: '',
        isViewDetail: this.props.isViewDetail
      };
    }

    componentDidMount() {
      this.onFetchListCategory();
    }

    componentWillReceiveProps(nextProps) {
      const {warrantyExpiration} = this.state;
      if (this.props.categoryDropdownList !== nextProps.categoryDropdownList) {
        const newList = nextProps.categoryDropdownList.map(el => {
          return {
            text: el.name,
            value: el.id
          };
        });
        this.setState({
          categoryList: newList
        });
      }

      if (this.props.templateInventoryItemProfile !== nextProps.templateInventoryItemProfile) {
        let selectedCategory = null;

        if (nextProps.templateInventoryItemProfile.categoryNames.length > 0 && this.state.categoryList && this.state.categoryList.length > 0)
        {
          selectedCategory = this.state.categoryList.find(x => x.text === nextProps.templateInventoryItemProfile.categoryNames[0]);
        }

        this.setState({
          name: nextProps.templateInventoryItemProfile.name,
          listImages: nextProps.templateInventoryItemProfile.images,
          attachmentFiles: nextProps.templateInventoryItemProfile.attachments,
          mfg: nextProps.templateInventoryItemProfile.mfg,
          model: nextProps.templateInventoryItemProfile.model,
          note: nextProps.templateInventoryItemProfile.note,
          style: nextProps.templateInventoryItemProfile.style,
          category: selectedCategory,
          warrantyExpiration: {...warrantyExpiration, warrantyDate: nextProps.templateInventoryItemProfile.warrantyExpirationIntValue, warrantyMonthYear: nextProps.templateInventoryItemProfile.warrantyExpirationTimeUnit === 0 ? {text: 'Months', value: monthYearType.month} : {text: 'Years', value: monthYearType.year}, warrantyType: nextProps.templateInventoryItemProfile.warrantyExpirationType === 0 ? {text: 'COE', value: dateType.coe} : {text: 'Purchase date', value: dateType.purchaseDate}}
        });
      }

      //var t = this.state.categoryList.find(x => x.text === nextProps.templateInventoryItemProfile.categoryNames.length[0]);
      console.log(this.state.category);
      if (this.props.SuggestInventoryItemInfo !== nextProps.SuggestInventoryItemInfo) {
        this.setState({
          suggestData: nextProps.SuggestInventoryItemInfo
        });
      }
    }

    onClose = () => {
      this.props.onClose();
    }

    renderErrorMsg = () => {
      const {errorMessageAutoComplete} = this.state;
      if (errorMessageAutoComplete) {
        return (
          <span className='cls-danger help-block'>
            {errorMessageAutoComplete}
          </span>
        );
      }

      return null;
    }

    onSubmit = (e) => {
      e.preventDefault();

      const {warrantyExpiration, name, model, mfg, note, style, calendarDate, listImages, attachmentFiles, category} = this.state;
      const categoryDropdown = this.refs.categoryDropdown.validate();

      if (!categoryDropdown) {
        return false;
      }

      this.props.dispatch({
        type: ProjectActionType.CREATE_NEW_INVENTORY_ITEM_ASYNC,
        params: {
          categoryId: category.value,

          name: name.trim(),
          model: model.trim(),
          mfg: mfg.trim(),
          note: note ? note.trim() : null,
          style: style ? style.trim() : null,

          warrantyExpirationIntValue: this.state.openSelectedCalendarDate ? null : ((warrantyExpiration.warrantyDate === '' || warrantyExpiration.warrantyDate === null) ? null : warrantyExpiration.warrantyDate),
          warrantyExpirationType: this.state.openSelectedCalendarDate ? '2' : warrantyExpiration.warrantyType.value,
          warrantyExpirationTimeUnit: this.state.openSelectedCalendarDate ? null : warrantyExpiration.warrantyMonthYear.value,
          warrantyExpirationDateValue: this.state.openSelectedCalendarDate ? (calendarDate ? formatTimezoneDateTime(Moment(calendarDate)) : null) : null,
          images: listImages,
          attachments: attachmentFiles
        }, callback: (id) => {
          this.props.onProceedToAssignLot(id);
        }
      });
    }

    onDrop = (accepted, rejected) => {
      const {listImages} = this.state;
      if (rejected.length) {
        const errorMsg = 'Only PNG, JPG, JPEG, BMP, TIFF supported.';
        this.setState({
          errorMsg: errorMsg
        });
      } else if ((accepted.length + listImages.length) > 5) {
        const errorMsg = 'Maximum 5 files uploaded.';
        this.setState({
          errorMsg: errorMsg
        });
      } else {
        this.handleFileUpload(accepted);
      }
    }

    onDropAttachments = (accepted) => {
      console.log("accepted", accepted)
      const {isAttachment, attachmentFiles} = this.state;
      if ((accepted.length + attachmentFiles.length) > 5) {
        const error = 'Maximum 5 files uploaded.';

        this.setState({
          errorAttachmentMsg: error
        });
      } else {
        console.log("isAttachment", isAttachment)
        this.handleFileUpload(accepted, isAttachment);
      }
    }

    onClearError = (name) => {
      this.setState({ [name]: null });
    };

    onFetchListCategory = (callback) => {
      this.props.dispatch({
        type: ProjectActionType.GET_LIST_CATEGORY_DROPDOWN_ASYNC,
        params: {
          projectId: this.props.projectId
        },
        callback
      });
    }

    renderError = (errorMsg, name) => {

      if (errorMsg) {
        setTimeout(() => this.onClearError(name), 5000);
        return (
          <div
            className='alert alert-danger'
            style={{ width: '100%', margin: '0 15px 15px' }}
          >
            <p style={{ fontSize: 14 }}>{errorMsg}</p>
            <i
              className='fa fa-close'
              style={{
                position: 'absolute',
                top: 14,
                right: 14,
                cursor: 'pointer'
              }}
              onClick={() => this.onClearError(name)}
            />
          </div>
        );
      }

      return null;
    };

    handlePdfThumbnail = (thumbnail, fileDataS3) => {
      console.log("handlePdfThumbnail", thumbnail, fileDataS3)
      const { projectId } = this.props;

      thumbnail.name = uuidv4();

      this.props.dispatch({
        type: CommonActionType.COMMON_UPLOAD_FILE_TO_S3_ASYNC,
        paramsUpload: {
          projectId,
          file: thumbnail,
          config: {
            ...this.awsCredential,
            path: `${this.awsCredential.path}/thumbnail`
          }
        },
        callback: (status, callbackData) => {
          if (status === true) {
            this.getFileUrl(fileDataS3, callbackData);
          }
        }
      });
    };

    getFileUrl = (fileData) => {
      const {attachmentFiles} = this.state;
      console.log(attachmentFiles, "attachmentFiles")
      let file = {};
      file.fileName = fileData.name;
      file.key = fileData.data.Key;
      file.url = fileData.data.Location;
      attachmentFiles.push(file);
      this.setState({
        attachmentFiles: attachmentFiles
      });
    }

    handleFileUpload = (files, isAttachment) => {
      const {projectId} = this.props;
      this.props.dispatch({
        type: CommonActionType.COMMON_SETUP_AWS_ASYNC,
        params: {
          resourcePath: isAttachment ? `projects/${projectId}/home-inventory/inventory-items-attachment-file` : `projects/${projectId}/home-inventory/inventory-items-image`
        },
        callback: awsCredential => {
          this.awsCredential = awsCredential;

          files.map(file => {
            file.uploadId = uuidv4();
            if (file.type === 'application/pdf') {
              //handle get pdf thumbnail
              this.props.dispatch({
                type: CommonActionType.COMMON_UPLOAD_FILE_TO_S3_ASYNC,
                paramsUpload: {
                  projectId,
                  file,
                  config: awsCredential
                },
                callback: (status, callbackData) => {
                  console.log("status", status)
                  if (status === 'pending') {
                    const { cancelUploadList } = this.state;
                    cancelUploadList[callbackData.uploadId] =
                      callbackData.cancelUpload;
                    this.setState({
                      cancelUploadList
                    });
                  } else if (status === 'delete') {
                    const { deleteUploadList } = this.state;
                    deleteUploadList[callbackData.uploadId] =
                      callbackData.deleteFile;
                    this.setState({
                      deleteUploadList
                    });
                  } else if (status === true) {
                    callbackData.name = file.name;
                    const data = file.preview;
                    console.log("data", data)
                    console.log("callbackData", callbackData)
                    generatePdfThumbnail(
                      data,
                      this.handlePdfThumbnail,
                      callbackData
                    );
                  }
                }
              });
            } else {
              //handle image file
              this.props.dispatch({
                type: CommonActionType.COMMON_UPLOAD_FILE_TO_S3_ASYNC,
                paramsUpload: {
                  projectId,
                  file,
                  config: awsCredential
                },
                callback: (status, callbackData) => {
                  callbackData.name = file.name;

                  if (status === 'pending') {
                    const { cancelUploadList } = this.state;
                    cancelUploadList[callbackData.uploadId] =
                      callbackData.cancelUpload;
                    this.setState({
                      cancelUploadList
                    });
                  } else if (status === 'delete') {
                    const { deleteUploadList } = this.state;
                    deleteUploadList[callbackData.uploadId] =
                      callbackData.deleteFile;
                    this.setState({
                      deleteUploadList
                    });
                  } else if (status === true) {
                    if (isAttachment) {
                      this.getFileUrl(callbackData, callbackData);
                    } else {
                      this.getImageUrl(callbackData, callbackData);
                    }
                  }
                }
              });
            }
          });
        }
      });
    }

    getImageUrl = (fileData) => {
      const {listImages} = this.state;
      let file = {};
      file.fileName = fileData.name;
      file.key = fileData.data.Key;
      file.url = fileData.data.Location;
      file.thumbnailKey = fileData.data.Key;
      file.thumbnailUrl = fileData.data.Location;
      listImages.push(file);
      this.setState({
        listImages: listImages
      });
    }

    onTogglePreviewImages = (url) => {
      this.setState({
        imagePreview: url
      });
    }

    onRemoveFiles = (name, id) => {
      name.splice(_.indexOf(name, _.find(name, { fileName: id})), 1);
      this.setState({
        [name]: name
      });
    }

    onChange = (e) => {
      //dropdown category list
      this.setState({
        category: e.value
      });
    }

    onChangeWarrantyDropdown = (e, type) => {
      const {warrantyExpiration} = this.state;
      this.setState({
        warrantyExpiration: {...warrantyExpiration, [type]: e.value}
      });
    }

    renderFileTypeIcon = (item) => {
      const extWord = ['doc', 'docx'];
      const extExcel = ['xls', 'xlsx'];
      const extPpt = ['ppt', 'pptx'];
      const extImage = ['jpg', 'jpeg', 'png', 'gif'];
      const extVideo = ['mp4', 'm4v', 'mid', 'mkv', 'webm', 'mov', 'avi', 'wmv'];
      const ext = item.fileName.split('.').pop().toLowerCase();
      if (extWord.includes(ext)) {return word;}
      else if (extExcel.includes(ext)) {return excel;}
      else if (extPpt.includes(ext)) {return ppt;}
      else if (extPpt.includes(ext)) {return ppt;}
      else if (extVideo.includes(ext)) {return video;}
      else if (ext === 'pdf') {return pdf;}
      else if (extImage.includes(ext)) {return item.url;}
      else {return other;}
    }

    renderFileUpload = () => {
      const {attachmentFiles} = this.state;
      return <ul className='inventory-attachments-files-list'>
        {
          attachmentFiles.map(file =>
            <li key={file.fileName}>
              <div className='file-info'>
                <div style={{
                  width: 50,
                  height: 60,
                  marginLeft: 15,
                  marginRight: 10,
                  borderRadius: 2,
                  verticalAlign: 'top',
                  backgroundImage: `url(${this.renderFileTypeIcon(file)})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  display: 'inline-block'
                }} onClick={this.state.isViewDetail ? () => this.onPreviewFilesAttachment(file) : () => {}} />
                <div style={{display: 'inline-block', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '80%', whiteSpace: 'nowrap'}} className='file-info'>
                  <span onClick={this.state.isViewDetail ? () => this.onPreviewFilesAttachment(file) : () => {}}>{file.fileName}</span>
                </div>
                <div style={{display: 'inline-block'}} className='remove-button-wrapper' onClick={() => this.onRemoveFiles(this.state.attachmentFiles, file.fileName)}>
                  <div className='remove-button icon-remove-ic' />
                </div>
              </div>
            </li>
          )
        }
      </ul>;
    }

    onPreviewFilesAttachment = (file) => {
      console.log("preview called")
      const extension = file.fileName.split('.').pop().toLowerCase();
      const imageType = ['jpg', 'jpeg', 'png', 'gif'];
      const videoType = ['mp4', 'm4v', 'mid', 'mkv', 'webm', 'mov', 'avi', 'wmv'];
      if (imageType.includes(extension)) {
        this.setState({
          show: true,
          previewUrl: file.url
        });
      }
      if (extension === 'pdf') {
        this.setState({
          isPreviewPDF: file.url
        }, () => {
          if (isMobile) {
            window.open(this.state.isPreviewPDF, '_blank');
          }
        });
      }
      if (videoType.includes(extension)) {
        this.setState({
          showDialog: true,
          videoUrl: file.url
        });
      }
    }

    handleClose = () => {
      this.setState({ show: false, previewUrl: null});
    }

    handleCloseVideo = (callback) => {
      this.setState({ showDialog: false, videoUrl: null}, callback);
    }

    onCustomAction = () => {
      this.props.onClose();
    }

    onChangeDateWarranty = (e) => {
      const {warrantyExpiration} = this.state;
      const warrantyDate = e.target.value;
      if (warrantyDate <= 999) {
        if (warrantyDate >= 0) {
          return this.setState({warrantyExpiration: {...warrantyExpiration, warrantyDate: e.target.value}});
        }
        return this.setState({warrantyExpiration: {...warrantyExpiration, warrantyDate: null}});
      }
      return '';
    }

    onChangeDate = (type) => (value) => {
      if (value) {
        if (Moment(value, 'MM/DD/YYYY', true).isValid()) {
          this.setState({
            [type]: value,
            error: {...this.state.error, [type]: null}
          });
        } else if (Moment(value, 'DD/MM/YYYY', true).isValid()) {
          let convertDate = (Moment(Moment(value, 'DD/MM/YYYY')).format('MM/DD/YYYY'));
          this.setState({
            [type]: convertDate,
            error: {...this.state.error, [type]: null}
          });
        } else if (Moment(value, 'YYYY/DD/MM', true).isValid()) {
          let convertDate = (Moment(Moment(value, 'YYYY/DD/MM')).format('MM/DD/YYYY'));
          this.setState({
            [type]: convertDate,
            error: {...this.state.error, [type]: null}
          });
        } else if (Moment(value, 'YYYY/MM/DD', true).isValid()) {
          let convertDate = (Moment(Moment(value, 'YYYY/MM/DD')).format('MM/DD/YYYY'));
          this.setState({
            [type]: convertDate,
            error: {...this.state.error, [type]: null}
          });
        } else {
          this.setState({
            error: {...this.state.error, [type]: 'Invalid date.'}
          });
        }
      } else {
        this.setState({
          [type]: value,
          error: {...this.state.error, [type]: null}
        });
      }
    }

    // renderNoFiles = () => {
    //   return <div className='inventory-attachment-no-files-block'>
    //     <img className='inventory-attachment-no-files-ic' src={folder} alt='no-files' />
    //     <p className='inventory-attachment-no-files-text'>No files</p>
    //   </div>;
    // }

    onToggleCalendarDate = () => {
      this.setState({
        openSelectedCalendarDate: true
      });
    }

    onToggleRegularDate= () => {
      this.setState({
        openSelectedCalendarDate: false
      });
    }

    //implement debounce input
    debounceTest = debounce((text, searchKey) => {
      if (searchKey.length < 1) {
        this.setState({
          errorMessageAutoComplete: 'This field is required'
        }, () => this.onFocusAutoComplete());
      }

      if (searchKey.length < 2) {
        this.setState({name: text, suggestData: []});
        return;
      }

      if (searchKey.length > 1) {
        this.setState({
          errorMessageAutoComplete: ''
        });
      }

      this.props.dispatch({
        type: ProjectActionType.GET_SUGGEST_TEMPLATE_NAME_ASYNC,
        params: {
          templateName: encodeURIComponent(text)
        }
      });
    }, 500);

    onSearchSuggestion = (event, text) => {
      const searchKey = text.trim();
      this.setState({name: text}, () => {this.debounceTest(text, searchKey);});
    }

    onFocusAutoComplete = () => {
      const {name} = this.state;

      if (!name) {
        this.setState({
          errorMessageAutoComplete: 'This field is required'
        }, () => this.onFocusAutoComplete);
      }
    }

    onChangeText =(e, type) => {
      this.setState({
        [type]: e.target.value
      });
    }

    render() {
      let {name, warrantyExpiration, mfg, model, note, style } = this.state;
      const {category, listImages, imagePreview, attachmentFiles, calendarDate, categoryList, openSelectedCalendarDate} = this.state;
      const {breadcrumbsHistory} = this.props;
      const { isViewDetail} = this.state;
      const acceptFileType = 'image/jpeg, image/png , image/bmp, image/jpg, image/tiff';
      //   const acceptFileAttach = 'image/jpeg, image/png, application/pdf, video/quicktime, video/x-quicktime, video/mp4, video/webm, audio/webm';
      const breadcrumbs = [
        {title: 'Inventory items', url: breadcrumbsHistory, onCustomAction: this.onCustomAction},
        {title: 'Add new inventory item', url: ''}
      ];
      return (
        <React.Fragment>
          <div className='home-libraries-inventory container-fluid'>
            <h4 style={{margin: '0px 0px 10px'}}>Add new inventory item</h4>
            <Form ref={c => { this.form = c; }} onSubmit={(e) => this.onSubmit(e)}>
              <Breadcrumb breadcrumbs={breadcrumbs} />
              { isViewDetail && this.state.isPreviewPDF && !isMobile && [
                <embed src={this.state.isPreviewPDF} className='pdf-preview-dialog' ref={ref => {this.embedPreview = ref;}} />,
                <i onClick={() => this.setState({isPreviewPDF: null})} className='close-embed-preview fa fa-close' />
              ]}

              {isViewDetail && <PreviewImage
                show={this.state.show}
                imageUrl={this.state.previewUrl}
                handleClose={this.handleClose}
              />}

              {isViewDetail && this.state.videoUrl && [
                <PreviewVideoWO
                // loading
                  data={this.state.videoUrl}
                  showDialog={this.state.showDialog}
                  handleCloseVideo={this.handleCloseVideo}
                />
              ]}
              <div className='add-new-category-item-add row'>
                <div className='col-md-6 col-xs-6'>
                  <div className='form-group'>
                    <label>Name <strong className='text-danger'>*</strong></label>
                    <Autocomplete
                      className='inputText'
                      inputProps={{
                        id: 'states-autocomplete',
                        className: 'form-control',
                        max: '254',
                        maxLength: '254',
                        name: 'name',
                        onFocus: this.onFocusAutoComplete
                      }}
                      wrapperStyle={{ position: 'relative' }}
                      value={name}
                      items={this.state.suggestData}
                      getItemValue={(item) => item.name}
                      onSelect={(value, item) => {
                        this.setState({name: value, suggestData: [item]}, () => {
                          this.props.dispatch({
                            type: ProjectActionType.GET_SUGGEST_DATA_ASYNC, params: {templateId: this.state.suggestData[0].id}, callback: () => this.setState({suggestData: []})
                          });
                        });
                      }}
                      onChange={this.onSearchSuggestion}
                      renderMenu={children => (
                        <div className='suggestion-menu'>
                          {children}
                        </div>
                      )}
                      renderItem={(item, isHighlighted) => (
                        <div
                          className={`item ${isHighlighted ? 'item-highlighted' : ''}`}
                          key={item.name}
                        >
                          {item.name}
                          {!isEmpty(item.images) && <span style={{marginLeft: 15}}><img className='category-img-item' src={!isEmpty(item.images) && item.images[0].thumbnailUrl} /></span>}
                        </div>
                      )}
                      ref='name'
                    />
                    {this.renderErrorMsg()}
                  </div>
                  <div className='form-group'>
                    <label>Inventory <strong className='text-danger'>*</strong></label>
                    <Dropdown
                      ref='categoryDropdown'
                      placeholder='Select Any'
                      style={{width: '100%'}}
                      optionLabel='text'
                      autoFocus={false}
                      filter={true}
                      className='filestring-dropdown filter-dropdown'
                      value={category}
                      options={categoryList}
                      onChange={(e) => this.onChange(e)}
                      errorMessage='This field is required.'/>
                  </div>
                  <div className='form-group'>
                    <label>MFG/Provider <strong className='text-danger'>*</strong></label>
                    <input
                      name='mfg'
                      ref='mfg'
                      placeholder='MFG'
                      className='form-control'
                      value={mfg}
                      onChange={(e) => this.setState({mfg: e.target.value})}
                      max='254'
                      maxLength='254'
                      validations={[Vali.required, Vali.maxlength]}
                    />
                  </div>
                  <div className='form-group'>
                    <label>Model/Type <strong className='text-danger'>*</strong></label>
                    <input
                      name='model'
                      ref='model'
                      placeholder='Model'
                      className='form-control'
                      max='254'
                      maxLength='254'
                      value={model}
                      onChange={(e) => this.setState({model: e.target.value})}
                      validations={[Vali.required, Vali.maxlength]}
                    />
                  </div>
                  <div className='form-group'>
                    <label>MFG Links</label>
                    <textarea
                      style={{minHeight: 100}}
                      name='note'
                      ref='note'
                      placeholder='MFG Links'
                      className='form-control'
                      max='1000'
                      maxLength='1000'
                      value={this.props.templateInventoryItemProfile.note}
                      onChange={(e) => this.setState({note: e.target.value})}
                    />
                  </div>
                  <div className='form-group'>
                    <label>Style</label>
                    <input
                      name='style'
                      ref='style'
                      placeholder='Style'
                      className='form-control'
                      max='254'
                      maxLength='254'
                      value={style}
                      onChange={(e) => this.setState({style: e.target.value})}
                    />
                  </div>
                  <div className='row'>
                    <div className='col-md-12 col-xs-12'>
                      <label>Warranty expiration</label>
                    </div>
                    <div className='row'>
                      <div className='col-md-7 col-xs-7'>
                        {openSelectedCalendarDate ? <div className='warranty-date'><Datetime
                          ref={ref => {
                            this.calendarDate = ref;
                          }}
                          inputProps={{ placeholder: 'MM/DD/YYYY' }}
                          timeFormat={false}
                          dateFormat='MM/DD/YYYY'
                          value={calendarDate}
                          onChange={this.onChangeDate('calendarDate')}
                          closeOnSelect={true}/></div> : <div className='warranty-date'>
                          <input
                            min='0'
                            style={{width: 50, border: 'none', borderBottom: '1px solid lightgray'}}
                            className='date-warranty'
                            ref={ref => {
                              this.warrantyDate = ref;
                            }}
                            type='number'
                            name='warrantyDate'
                            onFocus={() => this.setState({warrantyExpiration: {...warrantyExpiration, warrantyDate: null}})}
                            value={warrantyExpiration.warrantyDate || ''}
                            onChange={this.onChangeDateWarranty}
                          />
                          <Dropdown
                            onChange={(e) => this.onChangeWarrantyDropdown(e, 'warrantyMonthYear')}
                            className='filestring-dropdown filter-dropdown'
                            defaultValue={warrantyDateTimeSelection[1]}
                            value={warrantyExpiration.warrantyMonthYear}
                            options={warrantyDateTimeSelection}
                            style={{width: '28%', display: 'inline-block', marginLeft: 10, marginRight: 5}}
                            optionLabel='text'
                            placeholder='Any'
                            ref={ref => {
                              this.warrantyMonthYear = ref;
                            }} />

                          <span>from</span>
                          <Dropdown
                            onChange={(e) => this.onChangeWarrantyDropdown(e, 'warrantyType')}
                            className='filestring-dropdown filter-dropdown'
                            defaultValue={warrantyTypeSelection[0]}
                            value={warrantyExpiration.warrantyType}
                            options={warrantyTypeSelection}
                            style={{width: '42%', display: 'inline-block', marginLeft: 5, marginRight: 5}}
                            optionLabel='text'
                            placeholder='Any'
                            ref={ref => {this.warrantyType = ref;}} />
                        </div>}
                      </div>
                      <div style={{marginTop: 15}} className='col-md-5 col-xs-5'>
                        <div className='inventory-calendar-warranty'>
                          <div style={!openSelectedCalendarDate ? {backgroundColor: 'lightgray', borderRadius: '50%'} : {}} onClick={this.onToggleRegularDate} className='regular-date'><span style={{marginLeft: 9, fontSize: 30}}><img style={{marginBottom: 6}} src={regularDate} /></span></div>
                          <div style={openSelectedCalendarDate ? {backgroundColor: 'lightgray', borderRadius: '50%'} : {}} onClick={this.onToggleCalendarDate} className='calendar-date'><span style={{marginLeft: 8, fontSize: 30}}><img style={{marginBottom: 6}} src={calendarDateImg} /></span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-md-6 col-xs-6'>
                  {this.renderError(this.state.errorMsg, 'errorMsg')}
                  <div className='preview-inventory-items-image'>
                    <div className='container-fluid'>
                      <div className='row'>
                        <div className='col-md-12 col-xs-12'>
                          {imagePreview && <img
                            className='empty-category-image'
                            src={imagePreview || !isEmpty(listImages) ? imagePreview : emptyImages}
                            alt='no-files'
                          />}
                          { !imagePreview && <img
                            className='empty-category-image'
                            src={this.state.listImages && this.state.listImages[0] ? this.state.listImages[0].url : emptyImages}
                            alt='no-files'
                          />}
                        </div>
                      </div>
                    </div>
                    <div className='container-fluid'>
                      <div className='list-thumbnail-image-after-upload'>
                        <div className='row'>
                          {/* map img FIXME:*/}

                          <div style={{height: 70, display: 'flex', justifyContent: 'center'}} className='col-md-12 col-xs-12'>
                            {!isEmpty(listImages) && (
                              listImages.map((el, index) => {
                                return (
                                  <div key={index} className='image-file-after-upload col-md-2 col-xs-2 col-lg-2'>
                                    <span onClick={() => this.onRemoveFiles(this.state.listImages, el.fileName)} className='close'>&times;</span>
                                    <img className='category-img-item' onClick={() => this.onTogglePreviewImages(el.url)} src={el.url} />
                                  </div>
                                );
                              })
                            )}
                            {/* dropzone button add */}
                            {
                              listImages.length < 5 && <div className='image-file-after-upload col-md-2 col-xs-2 col-lg-2'>
                                <Dropzone
                                  disableClick
                                  accept={acceptFileType}
                                  ref={node => {
                                    this.dropzoneRef = node;
                                  }}
                                  className='category-images-dropzone'
                                  onDrop={this.onDrop.bind(this)}>
                                  <button
                                    onClick={(e) => {
                                      e.preventDefault();
                                      this.dropzoneRef.open();
                                    }}
                                    className='add-image-category btn btn-primary btn-siteone-default'>
                                    <img
                                      src={plusIcon} />
                                  </button>
                                </Dropzone>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* attachments */}
                  <div className='row'>
                    <div className='col-md-12 col-xs-12 margin-left-15'>
                      <span className='font-normal'>
                            Attachments
                      </span>
                    </div>
                  </div>
                  <div style={{marginLeft: 0}} className='row'>
                    <div className='dropzone-attachment-inventory-items col-md-12 col-xs-12'>
                      {this.renderError(this.state.errorAttachmentMsg, 'errorAttachmentMsg')}
                      <Dropzone
                        disableClick
                        ref={node => { this.dropzoneAttachments = node; }}
                        onDrop={this.onDropAttachments}
                        className='inventory-attachments-dropzone'
                      >
                        <div className='upload-block'>
                          <span className='files-upload-ic'>
                            <i className='fa fa-cloud-upload' />
                          </span>
                            Drag files here or{' '}
                          <span
                            className='files-browse-txt'
                            onClick={() => { this.dropzoneAttachments.open(); }}
                          >
                            browse.
                          </span>
                        </div>
                      </Dropzone>
                    </div>
                    <div className='col-md-12 col-xs-12'>
                      <div style={{marginLeft: -20}} className='inventory-attachments-files-list container-fluid'>
                        {attachmentFiles.length ? this.renderFileUpload() : ''}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12 col-xs-12'>
                  <span className='btn btn-default btn-siteone-default' onClick={this.onClose}>Cancel</span>
                  <Submit disabled={!name} className='btn btn-primary btn-siteone'>Create</Submit>
                </div>
              </div>
            </Form>
          </div>
        </React.Fragment>
      );
    }

}

const mapStateToProps = state => {
  return {
    categoryDropdownList: state.ProjectStore.categoryDropdownList,
    SuggestInventoryItemInfo: state.ProjectStore.SuggestInventoryItemInfo,
    templateInventoryItemProfile: state.ProjectStore.templateInventoryItemProfile
  };
};

export default connect(mapStateToProps)(AddNewInventoryItemsModal);



// WEBPACK FOOTER //
// ./src/Projects/Components/Inventory/item-add.js